export default "/images/d540114471f5ac0d1a371b60162f69af.avif";